import { render, staticRenderFns } from "./homepage-trending-djs.vue?vue&type=template&id=4b566a82&scoped=true"
import script from "./homepage-trending-djs.vue?vue&type=script&setup=true&lang=js"
export * from "./homepage-trending-djs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homepage-trending-djs.vue?vue&type=style&index=0&id=4b566a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b566a82",
  null
  
)

export default component.exports